export default __webpack_public_path__ + "static/media/t12.f77d1575.jpg";